var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h2", { staticClass: "border-none" }, [
      _vm._v("Do you have any other interests or hobbies?"),
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "spacer-t-5" },
      [
        _vm.suggestedPersonalInterests && _vm.suggestedPersonalInterests.length
          ? _c(
              "div",
              { staticClass: "flex flex-wrap" },
              [
                _c("strong", [_vm._v("Suggestions")]),
                _vm._v(" "),
                _vm._l(_vm.suggestedPersonalInterests, function (suggestion) {
                  return _c(
                    "div",
                    { key: suggestion.id, staticClass: "underline spacer-x-1" },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "cursor-pointer",
                          on: {
                            click: () => {
                              _vm.$emit("selected", suggestion)
                            },
                          },
                        },
                        [_vm._v(_vm._s(suggestion.name))]
                      ),
                    ]
                  )
                }),
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c("search-picker", {
          staticClass: "margin-y-1",
          attrs: {
            "full-width": true,
            "with-icon": true,
            "with-popper": true,
            "get-data": _vm.getPersonalInterests,
            current: _vm.personalInterests,
            placeholder: "Add topic",
          },
          on: {
            selected: (option) => {
              _vm.$emit("selected", option)
            },
          },
          scopedSlots: _vm._u([
            {
              key: "list-item-content",
              fn: function ({ option }) {
                return [
                  option.group
                    ? _c("div", { staticClass: "search-picker__subtext" }, [
                        _c("span", [_vm._v(_vm._s(option.group))]),
                      ])
                    : _vm._e(),
                ]
              },
            },
          ]),
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "w-full flex flex-wrap" },
      _vm._l(_vm.personalInterests, function (interest, index) {
        return _c(
          "div",
          { key: interest.id, staticClass: "category category--selected" },
          [
            _vm._v("\n      " + _vm._s(interest.name) + "\n      "),
            _c("i", {
              staticClass: "fa fa-times",
              on: {
                click: function ($event) {
                  return _vm.$emit(
                    "unselect",
                    interest.id,
                    index,
                    interest.name
                  )
                },
              },
            }),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("div", { staticClass: "spacer-b-2 lead-text" }, [
        _vm._v("Add your hobbies to get more opportunities you'll enjoy"),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "flex flex-row flex-wrap gray-500 w-2/3 justify-between",
        },
        [
          _c("div", { staticClass: "info-item" }, [
            _c(
              "div",
              { staticClass: "w-2/10 flex justify-center align-center" },
              [_c("i", { staticClass: "fa fa-microphone" })]
            ),
            _vm._v(" Brand Ambassadorships"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-item" }, [
            _c(
              "div",
              { staticClass: "w-2/10 flex justify-center align-center" },
              [_c("i", { staticClass: "fa fa-phone" })]
            ),
            _vm._v(" Video-shoutouts"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-item" }, [
            _c(
              "div",
              { staticClass: "w-2/10 flex justify-center align-center" },
              [_c("i", { staticClass: "fa fa-comments" })]
            ),
            _vm._v(" Social Media Campaigns"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "info-item" }, [
            _c(
              "div",
              { staticClass: "w-2/10 flex justify-center align-center" },
              [_c("i", { staticClass: "fa fa-camera" })]
            ),
            _vm._v(" Meet & Greets"),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }